<div class="header-arrow" [ngClass]="{ 'arrow-lg': size === 'lg', 'arrow-sm': size === 'sm' }" (click)="triggerToggle($event)">
    <i class="fa" [ngClass]="{ 'fa-angle-down': !opened, 'fa-angle-up': opened }"></i>
</div>
